import React from "react"

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { CssTextField } from "./StyledComponent";
import moment from "moment";

const DatePickerProject = (props) => {
  const [value, setValue] = React.useState(moment());
  const {label, setDate, initDate, initDefaultDate} = props

  const handleChange = (newValue) => {
    setValue(newValue);
    setDate(newValue)
  };

  React.useEffect(() => {
    if(initDate) {
      setValue(initDate)
      initDefaultDate(initDate)
    }
  }, [initDate, initDefaultDate])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DesktopDatePicker
        label={label}
        inputFormat="DD/MM/yyyy"
        value={value}
        disablePast={true}
        onChange={e => handleChange(e)}
        minDate={value}
        renderInput={(params) => <CssTextField {...params} disabled />}
      />
    </LocalizationProvider>
  )
}

export default DatePickerProject;